export default function PHP_getLine() {
  return (
    <div>
      <h1>PHP_getLine</h1>
    </div>
  );
}
